var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Container } from '../../../common/styles/container';
import { Paragraph } from '../../../atoms/Paragraph';
// Utils
import styled from 'styled-components';
// Types
import { grey } from '../../../common/styles/colours';
export var PrefixedDropdownListOptionLabelContainer = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " > span {\n    padding-right: 4px;\n    color: ", ";\n  }\n"], ["\n  ", " > span {\n    padding-right: 4px;\n    color: ", ";\n  }\n"])), Paragraph, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.contentAccessory) !== null && _b !== void 0 ? _b : grey[500];
});
var templateObject_1;
//# sourceMappingURL=PrefixedDropdownListOptionLabelContainer.js.map